import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, AddCircle as IconAddCircle } from "@mui/icons-material";
import * as modeloService from "../../services/modeloService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setResults, setListModelo,  setListArea } from '../../redux/modelSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";
import AreaEdit from '../../components/AreaEdit';
import AreaObjectiveEdit from '../../components/AreaObjectiveEdit';
import AreaObjectiveCriterionEdit from '../../components/AreaObjectiveCriterionEdit';

const Index = () => {
    const { isReadOnly } = useMantenimiento("modelo");
    const filters = useSelector((state) => state.modelSearch.filters);
    const listModelo = useSelector((state) => state.modelSearch.listModelo);
    const listArea = useSelector((state) => state.modelSearch.listArea);
    
    const [selectIdModelo, setSelectIdModelo] = useState(null);
    const [selectModelo, setSelectModelo] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [openAreaEdit, setOpenAreaEdit] = useState(false)
    const openCloseAreaEdit = () => { setOpenAreaEdit(!openAreaEdit); }
    const [selectIdArea, setSelectIdArea] = useState(null);
    const [selectArea, setSelectArea] = useState(null);

    const [openAreaObjetivoEdit, setOpenAreaObjetivoEdit] = useState(false)
    const openCloseAreaObjetivoEdit = () => { setOpenAreaObjetivoEdit(!openAreaObjetivoEdit); }
    const [selectIdAreaObjetivo, setSelectIdAreaObjetivo] = useState(null);
    const [selectAreaObjetivo, setSelectAreaObjetivo] = useState(null);
    
    const [openAreaObjetivoCriterioEdit, setOpenAreaObjetivoCriterioEdit] = useState(false)
    const openCloseAreaObjetivoCriterioEdit = () => { setOpenAreaObjetivoCriterioEdit(!openAreaObjetivoCriterioEdit); }
    const [selectIdAreaObjetivoCriterio, setSelectIdAreaObjetivoCriterio] = useState(null);

    const [cargando, setCargando] = useState(false);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Al guardar un area, objetivo o criterio el listado se vuelve a consultar para
    // que el cambio se vea de inmediato.
const setAreaNew = () => {
        fetchResults();
    }
    const setAreaObjetivoNew = () => {
        fetchResults();
    }
    const setAreaObjetivoCriterioNew = () => {
        fetchResults();
    }

    const fetchResults = async () => {
        setCargando(true);

        await modeloService.getsAreaObjetivoCriterioResumenView({ ...filters, limite: 100 })
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchListModelo = async () => {
        await modeloService.getsListModelo()
            .then((data) => {
                dispatch(setListModelo(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchListArea = async (idModelo) => {
        await modeloService.getsListArea(idModelo)
            .then((data) => {
                dispatch(setListArea(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }

    useEffect(() => {
        fetchListModelo();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'codigoArea', headerName: 'Cod', width: 30, sortable: false, headerAlign: 'left', align: 'center', },
        { field: 'area', headerName: 'Area', width: 150, sortable: false, headerAlign: 'left'
            , renderCell: (cellValues) => {
                return (<Typography
                    sx={{ cursor: isReadOnly ? 'default' : 'pointer', fontSize: 'inherit', textDecoration: isReadOnly ? 'none' : 'underline', }}
                    onClick={isReadOnly ? undefined : () => {
                        setSelectIdArea(cellValues.row.idArea);
                        setSelectArea(cellValues.row.area);
                        setSelectIdModelo(cellValues.row.idModelo)
                        setSelectModelo(cellValues.row.modelo)
                        openCloseAreaEdit();
                    }}
                >
                    {cellValues.row.area}
                </Typography>)
            }
        },
        { field: 'new_area', headerName: '', width: 30, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return isReadOnly ? null : <IconAddCircle aria-label="agregar" align={"center"} onClick={() => {
                    setSelectIdArea(0)
                    setSelectArea("");
                    openCloseAreaEdit()
                }}>
                </IconAddCircle>;
            }
        },
        { field: 'codigoObjetivo', headerName: 'Cod', width: 30, sortable: false, headerAlign: 'left', align: 'center', },
        // { field: 'destreza', headerName: 'Destreza', width: 150, sortable: false, headerAlign: 'left'},
        { field: 'objetivo', headerName: 'Objetivo', width: 150, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return (<Typography
                    sx={{ cursor: isReadOnly ? 'default' : 'pointer', fontSize: 'inherit', textDecoration: isReadOnly ? 'none' : 'underline', }}
                    onClick={isReadOnly ? undefined : () => {
                        setSelectIdAreaObjetivo(cellValues.row.idAreaObjetivo);
                        setSelectAreaObjetivo(cellValues.row.objetivo);
                        setSelectIdArea(cellValues.row.idArea);
                        setSelectArea(cellValues.row.area);
                        setSelectIdModelo(cellValues.row.idModelo)
                        setSelectModelo(cellValues.row.modelo)
                        openCloseAreaObjetivoEdit();
                    }}
                >
                    {cellValues.row.objetivo}
                </Typography>)
            }
        },
        { field: 'new_objetivo', headerName: '', width: 30, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return isReadOnly ? null : <IconAddCircle aria-label="agregar" align={"center"} onClick={() => {
                    setSelectIdAreaObjetivo(0)
                    setSelectAreaObjetivo("")
                    setSelectIdArea(cellValues.row.idArea);
                    setSelectArea(cellValues.row.area);
                    setSelectIdModelo(cellValues.row.idModelo)
                    setSelectModelo(cellValues.row.modelo)
                    openCloseAreaObjetivoEdit()
                }}>
                </IconAddCircle>;
            }
        },
        { field: 'valor', headerName: 'Val', width: 30, sortable: false, headerAlign: 'left', align: 'center', },
        { field: 'descripcion', headerName: 'Criterio', width: 150, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return (<Typography
                    sx={{ cursor: isReadOnly ? 'default' : 'pointer', fontSize: 'inherit', textDecoration: isReadOnly ? 'none' : 'underline', }}
                    onClick={isReadOnly ? undefined : () => {
                        setSelectIdAreaObjetivoCriterio(cellValues.row.id);
                        setSelectIdAreaObjetivo(cellValues.row.idAreaObjetivo);
                        setSelectAreaObjetivo(cellValues.row.objetivo);
                        setSelectIdArea(cellValues.row.idArea);
                        setSelectArea(cellValues.row.area);
                        console.log(cellValues.row.idAreaObjetivo)
                        openCloseAreaObjetivoCriterioEdit();
                    }}
                >
                    {cellValues.row.descripcion}
                </Typography>)
            }
        },
        { field: 'new_criterio', headerName: '', width: 30, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return isReadOnly ? null : <IconAddCircle aria-label="criterio" align={"center"} onClick={() => {
                    setSelectIdAreaObjetivoCriterio(0)
                    setSelectIdAreaObjetivo(cellValues.row.idAreaObjetivo);
                    setSelectAreaObjetivo(cellValues.row.objetivo);
                    setSelectIdArea(cellValues.row.idArea);
                    setSelectArea(cellValues.row.area);
                    openCloseAreaObjetivoCriterioEdit()
                }}>
                </IconAddCircle>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Modelos
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-modelo" shrink>Modelo</InputLabel>
                                    <Select
                                        native
                                        label="Modelo"
                                        value={filters.idModelo}
                                        onChange={(event, newValue) => {
                                            dispatch(setValue({name: "idModelo", value: event.target.value}))
                                            if (event.target.value != null)
                                                fetchListArea(event.target.value)
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idModelo',
                                            id: 'input-modelo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                        {listModelo.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-area" shrink>Area</InputLabel>
                                    <Select
                                        native
                                        label="Area"
                                        value={filters.idArea}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idArea", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idArea',
                                            id: 'input-area',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listArea.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <TextField
                                    // required
                                    name="destreza"
                                    label="Destreza"
                                    value={filters.destreza}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "destreza", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <TextField
                                    // required
                                    name="objetivo"
                                    label="Objetivo"
                                    value={filters.objetivo}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "objetivo", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <TextField
                                    // required
                                    name="criterio"
                                    label="Criterio"
                                    value={filters.criterio}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "criterio", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                pageSize={100}
                                showToolbar={true}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <AreaEdit id={selectIdArea} sliceKey="areaEdit" open={openAreaEdit} openClose={openCloseAreaEdit} setNewAreaSaved={setAreaNew} idModelo={selectIdModelo} isReadOnly={isReadOnly} />
                <AreaObjectiveEdit id={selectIdAreaObjetivo} sliceKey="areaObjetivoEdit" open={openAreaObjetivoEdit} openClose={openCloseAreaObjetivoEdit} setNewAreaObjetivoSaved={setAreaObjetivoNew} idArea={selectIdArea} area={selectArea} idModelo={selectIdModelo} isReadOnly={isReadOnly} />
                <AreaObjectiveCriterionEdit id={selectIdAreaObjetivoCriterio} sliceKey="areaObjetivoCriterioEdit" open={openAreaObjetivoCriterioEdit} openClose={openCloseAreaObjetivoCriterioEdit} setNewAreaObjetivoCriterioSaved={setAreaObjetivoCriterioNew} idArea={selectIdArea} idAreaObjetivo={selectIdAreaObjetivo} areaObjetivo={selectAreaObjetivo} isReadOnly={isReadOnly} />
            </Grid>
        </div>
    )
}
export default Index
